// extracted by mini-css-extract-plugin
export var askAiIcon = "_o3-j";
export var category = "_o3-9";
export var categoryHeader = "_o3-e";
export var container = "_o3-0";
export var group = "_o3-a";
export var groupItems = "_o3-f";
export var groupSeparator = "_o3-k";
export var loading = "_o3-1";
export var noResults = "_o3-3";
export var placeholder = "_o3-2";
export var resultContent = "_o3-5";
export var resultIcon = "_o3-c";
export var resultItem = "_o3-g";
export var resultMeta = "_o3-8";
export var resultSubtitle = "_o3-7";
export var resultSuffix = "_o3-i";
export var resultTitle = "_o3-6";
export var resultsList = "_o3-4";
export var searchGroup = "_o3-d";
export var selected = "_o3-h";
export var subgroup = "_o3-b";